import React from 'react';
import { FullHeaderLeftSideFullPanelLayout } from 'layouts/fullHeader.LeftSideFullPanel.layout';

const ReportingOld: React.FC = () => {
  return (
    <div id="ReportingOld" data-testid="ReportingOld" className="reporting-old">
      <FullHeaderLeftSideFullPanelLayout enableHeaderGlobalBar={true}>
        <iframe
          title="Locate 1.0"
          src={`${process.env.REACT_APP_CURRENT_VERSION_URL}/jreports?iframe=true`}
          scrolling="no"
          frameBorder="no"
          width="100%"
          height="100%"
        />
      </FullHeaderLeftSideFullPanelLayout>
    </div>
  );
};

export default React.memo(ReportingOld);
